import { Component, Prop } from 'vue-property-decorator';
import SdInputBase from '../SdInputBase';
import DatePicker from 'vue2-datepicker';
import moment from 'moment';
import i18n from '../../../lang/index';

@Component({
    components: { DatePicker },
    computed: {
        content: {
            get() {
                return this.$props.value;
            },
            set(value) {
                if (!value) {
                    this.$emit('input', null);
                    return;
                }
                const date = moment.utc(value.getDate() + '/' + (value.getMonth() + 1) + '/' + value.getFullYear(), 'DD/MM/YYYY');
                this.$emit('input', date.isValid() ? date : null);
            }
        }
    }
})
export default class SdInputDatepicker extends SdInputBase {
    @Prop() minDate?: moment.Moment | null;
    @Prop() maxDate?: moment.Moment | null;
    @Prop() isInvalidDate?: boolean;
    @Prop() type?: string | null;
    @Prop() placeholderFormat?: string | null;
    momentFormat: any = {
        // Date to String
        stringify(value) {
            return value && i18n.locale ? moment(value).format('L') : '';
        },
        // String to Date
        parse(value) {
            return value ? moment(value, 'L').toDate() : null;
        }
    };

    get datepickerFormat() {
        const l = 'L';

        return this.placeholderFormat
            ? this.placeholderFormat
            : (moment().locale(this.$i18n.locale).localeData() as any)._longDateFormat[l];
    }

    onBlur(actualPannel) {
        if (actualPannel === 'NONE') {
            this.focused = false;
            this.dirty = true;
        }
    }
}
